import EnvFeatures from './EnvFeatures';
import RunMode from './RunMode';
import {serialize} from 'uri-js';
import querystring from 'querystring';

function getRunMode() {
  let mode = RunMode.DEVELOPMENT;
  switch ((process.env.NODE_ENV || '').toUpperCase()) {
    case RunMode.DEVELOPMENT:
    case RunMode.STAGING:
    case RunMode.PILOT:
    case RunMode.PRODUCTION:
      mode = process.env.NODE_ENV.toUpperCase();
      break;
    default:
      console.log('process.env.NODE_ENV not defined.  Defaulting to runMode DEVELOPMENT.');
      break;
  }
  return mode;
}

function shouldCluster() {
  if (process.env.NO_CLUSTER) {
    return false;
  }
  return getRunMode() !== RunMode.DEVELOPMENT || process.env.NODE_CLUSTER;
}

const port = parseInt(process.env.PORT) || 3000;
const host = process.env.HOST || 'localhost';
const scheme = process.env.SCHEME || 'http';
const secure = scheme === 'https';
const externalPort = process.env.EXTERNAL_PORT
  ? parseInt(process.env.EXTERNAL_PORT)
  : port;

const externalHost = process.env.EXTERNAL_HOST || host;

class Settings {

  static envFeatures = new EnvFeatures();

  static runMode = getRunMode();

  static inBrowser = !!process.env.BROWSER;

  static shouldCluster = shouldCluster();

  static port = port;

  static externalPort = externalPort;

  static host = host;

  static externalHost = externalHost;

  static scheme = scheme;

  static secure = secure;

  static uri = serialize({
    scheme: scheme,
    host: externalHost,
    port: externalPort
  });

  static buildUri(path, query) {
    return serialize({
      scheme: scheme,
      host: externalHost,
      port: externalPort,
      path: path,
      query: querystring.stringify(query)
    });
  }

}

export default Settings;



// WEBPACK FOOTER //
// ./src/utils/Settings.js